const decimateLine = (data, maxPoints) => {
  if (!Array.isArray(data) || data.length <= maxPoints) {
    return data.map((y, i) => ({ i, y }));
  }
  const buckets = maxPoints;
  const bucketSize = data.length / buckets;
  const out = [];
  for (let b = 0; b < buckets; b++) {
    const start = Math.floor(b * bucketSize);
    const end = Math.floor((b + 1) * bucketSize);
    let minY = Number.POSITIVE_INFINITY;
    let maxY = Number.NEGATIVE_INFINITY;
    let minI = start;
    let maxI = start;
    for (let idx = start; idx < end; idx++) {
      const v = data[idx];
      if (v < minY) {
        minY = v;
        minI = idx;
      }
      if (v > maxY) {
        maxY = v;
        maxI = idx;
      }
    }
    if (!Number.isFinite(minY) || !Number.isFinite(maxY)) continue;
    if (minI <= maxI) {
      out.push({ i: minI, y: minY });
      if (maxI !== minI) out.push({ i: maxI, y: maxY });
    } else {
      out.push({ i: maxI, y: maxY });
      if (minI !== maxI) out.push({ i: minI, y: minY });
    }
  }
  out.sort((a, b) => a.i - b.i);
  return out;
};

export { decimateLine };

